import { render } from "./FilterTeamPerformance.vue?vue&type=template&id=19f28efd&scoped=true"
import script from "./FilterTeamPerformance.vue?vue&type=script&lang=js"
export * from "./FilterTeamPerformance.vue?vue&type=script&lang=js"

import "./FilterTeamPerformance.vue?vue&type=style&index=0&id=19f28efd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19f28efd"

export default script